import styled from 'styled-components';
import { theme } from '../theme';

export const ProgressContainer = styled.div`
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  background: ${theme.colors.background.card};
  border-bottom: 1px solid ${theme.colors.border.light};
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.sm} ${theme.spacing.md};
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  background: ${theme.colors.background.secondary};
  border-radius: ${theme.borderRadius.full};
  overflow: hidden;
  margin-bottom: ${theme.spacing.sm};
`;

export const ProgressFill = styled.div<{ $percentage: number }>`
  height: 100%;
  width: ${props => props.$percentage}%;
  background: linear-gradient(90deg, ${theme.colors.primary} 0%, ${theme.colors.secondary} 100%);
  border-radius: ${theme.borderRadius.full};
  transition: width 0.3s ease;
`;

export const ProgressInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  color: ${theme.colors.text.secondary};
`;

export const StepIndicator = styled.div`
  display: flex;
  justify-content: center;
  gap: ${theme.spacing.xs};
  margin-top: ${theme.spacing.sm};
`;

export const StepDot = styled.div<{ $isActive: boolean; $isComplete: boolean; $isSkipped: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: ${theme.borderRadius.full};
  background: ${props => {
    if (props.$isComplete) return theme.colors.success;
    if (props.$isSkipped) return theme.colors.warning;
    if (props.$isActive) return theme.colors.primary;
    return theme.colors.background.secondary;
  }};
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.2);
  }
`;

